/**
 * @author waseem.mirza
 */
Vue.mixin({
  data() {
    return {
      tag: "Instrumentation"
    };
  },

  methods: {
    _currentTimeMillis() {
      return new Date().getTime().toString();
    },

    _appendCommonData(attrs) {
      attrs["userAgent"] = navigator.userAgent;
      attrs["installId"] = this.getInstallId(); // install id will remain until app data is cleared
      attrs["flow_id"] = attrs["transactionId"] = this.getTransactionId(); // new value for every time the app is launched
    },

    _appendMerchantData(attrs) {
      let merchant =
        this.$store.state.bill && this.$store.state.bill.accessToken;
      if (merchant) {
        attrs["merchantId"] = merchant;
      }
    },

    _appendUserData(attrs) {
      if (attrs && !attrs.userId) {
        const userId =
          this.$store.state.credentials && this.$store.state.credentials.userId;
        if (userId) {
          attrs["userId"] = userId;
        }
      }
    },

    _appendAction(attrs) {
      let action = this.$store.getters.getAction();
      if (action) {
        attrs["action"] = action;
        try {
          this._appendAmountBreakup(attrs, action);
        } catch (e) {
          this.log(this.tag, "AmountBreakup not added due to error");
        }
      }
    },

    _appendAmountBreakup(attrs, action) {
      let actionDetails = {};
      if (action === "clear_pp_load_n_pay") {
        actionDetails["clear_pp"] = this.$store.getters.getActionDetails(
          "clear_pp"
        );
        actionDetails["load_n_pay"] = this.$store.getters.getActionDetails(
          "load_n_pay"
        );
      } else {
        actionDetails[action] = this.$store.getters.getActionDetails(action);
      }

      if (actionDetails) {
        attrs["amount"] = {};
        for (let key in actionDetails) {
          if (actionDetails.hasOwnProperty(key)) {
            let obj = actionDetails[key];
            let objForEvent = {};
            if (obj.view) {
              let arr = obj.view;
              if (arr && arr.length > 0) {
                for (let i = 0; i < arr.length; i++) {
                  if (i === 0) {
                    objForEvent[arr[i].header_text] = arr[i].value;
                  } else {
                    objForEvent[arr[i].text] = arr[i].value;
                  }
                }
              }
            }
            if (obj.load_amount) {
              objForEvent["load_amount"] = obj.load_amount;
            }

            attrs["amount"][key] = objForEvent;
          }
        }

        this.log(this.tag, attrs["amount"]);
      }
    },

    _createEvent(event, name) {
      if (!event) {
        event = {};
      }
      event["name"] = name;
      event["timestamp"] = this._currentTimeMillis();

      let attrs = event.attrs;
      if (!attrs) {
        attrs = event["attrs"] = {};
      }
      this._appendCommonData(attrs);
      this._appendMerchantData(attrs);
      this._appendAction(attrs);
      this._appendUserData(attrs);

      return event;
    },

    _publishEvent(event) {
      this.$store.dispatch("publishEvent", event);
    },

    _publishPublicEvent(event) {
      this.$store.dispatch("publishPublicEvent", event);
    },

    publishEvent(obj, eventName, publishPublicEvt) {
      let event = this._createEvent(obj, eventName);
      this.log(this.tag, event);

      let isWithAuth =
        this.$store.state.credentials &&
        this.$store.state.credentials.accessToken;

      if (isWithAuth && !publishPublicEvt) {
        this._publishEvent([event]);
      } else {
        this._publishPublicEvent([event]);
      }

      try {
        newrelic.addPageAction(eventName, event);
      } catch (e) {
        this.log(this.tag, e);
      }
    },

    publishCleverTapEvent(eventData, eventName, pageName) {
      eventData["event_name"] = eventName;
      eventData["timestamp"] = this._currentTimeMillis();
      eventData["userAgent"] = navigator.userAgent;
      eventData["screen"] = pageName;
      this.$store.dispatch("publishPPallEvent", eventData);
    },

    publishEventWithCleverTap(
      data,
      eventName,
      pageName,
      isPublicEvent = false
    ) {
      const eventData = JSON.parse(JSON.stringify(data));
      if (eventData && !eventData.attrs) {
        eventData["attrs"] = {};
      }
      eventData["attrs"]["screen"] = pageName;
      //   this.publishCleverTapEvent(data, eventName, pageName);
      this.publishEvent(eventData, eventName, isPublicEvent);
    }
  }
});
